import loadable from '@loadable/component';

export const CwSiteWrapper = loadable(
  () => import(/* webpackChunkName: "cw-site" */ './CwSiteWrapper'),
);
